export default __webpack_public_path__ + "static/media/next_disabled.183d04ce.svg";